/**
 * Electrical Installation Certificate (EIC) - Default Blank State
 */

const today = new Date().toISOString().split('T')[0];

export default {
  contractor: {
    companyName: '',
    contractorAddress: '',
    contractorEmail: '',
    contractorPhone: '',
    schemeName: '',
    schemeReference: '',
    engineerName: '',
    engineerCardNumber: '',
    notificationDate: today
  },
  client: {
    clientName: '',
    clientAddress: '',
    clientEmail: '',
    clientPhone: ''
  },
  installation: {
    installationAddress: '',
    installationDescription: '',
    extentLimitation: '',
    installationType: '',
    mainSupply: '',
    mainProtectiveDevice: '',
    mainIsolator: ''
  },
  supplyCharacteristics: {
    nominalVoltage: 230,
    externalZe: '',
    earthingType: '',
    psc: '',
    mainFuseSize: '',
    mainBonding: '',
    supplyCable: ''
  },
  circuits: [
    {
      circuitNumber: '1',
      dbName: '',
      circuitDescription: '',
      location: '',
      phase: '',
      protectiveDevice: '',
      deviceRating: '',
      maxZs: '',
      measuredZs: '',
      rcdType: 'None',
      rcdTripTime1x: '',
      rcdTripTime5x: '',
      insulationResistanceLL: '',
      insulationResistanceLE: '',
      insulationResistanceNE: '',
      testResult: ''
    }
  ],
  inspection: [
    {
      inspectionItem: '',
      inspectionResult: '',
      inspectionNotes: ''
    }
  ],
  declaration: {
    certificateNumber: `EIC-${Date.now()}`,
    issueDate: today,
    engineerSignature: '',
    customerSignature: '',
    notes: ''
  }
};